import { render, staticRenderFns } from "./tagOperation.vue?vue&type=template&id=635cb1cf&scoped=true"
import script from "./tagOperation.vue?vue&type=script&lang=js"
export * from "./tagOperation.vue?vue&type=script&lang=js"
import style0 from "./tagOperation.vue?vue&type=style&index=0&id=635cb1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cb1cf",
  null
  
)

export default component.exports